import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_provider/${agro_exporter_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchProvider(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_provider/${agro_exporter_id}/fetch_provider/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchLiquidationMonthly(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_provider/${agro_exporter_id}/fetch_liquidations_monthly/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchTotalAdvances(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_provider/${agro_exporter_id}/fetch_total_advances/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchTotalsMonthly(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_provider/${agro_exporter_id}/fetch_totals_monthly/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchCropSizes(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_provider/${agro_exporter_id}/fetch_crop_sizes/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchCropSizeLabels(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_provider/${agro_exporter_id}/fetch_crop_size_labels/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchTotalsWeekly(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_provider/${agro_exporter_id}/fetch_totals_weekly/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchCropSizeWeekly(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_provider/${agro_exporter_id}/fetch_crop_size_weekly/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchCropSizeEarningWeekly(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_provider/${agro_exporter_id}/fetch_crop_size_earning_weekly/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchLiquidationsTotal(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_provider/${agro_exporter_id}/fetch_liquidations_total/${agro_exporter_process_id}/${provider_type}/${provider_id}`
    );
  },

  fetchLiquidations(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id,
    current_page,
    rows_per_page
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_provider/${agro_exporter_id}/fetch_liquidations/${agro_exporter_process_id}/${provider_type}/${provider_id}/${current_page}/${rows_per_page}`
    );
  },

  fetchLiquidation(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_type,
    provider_id,
    liquidation_code
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_provider/${agro_exporter_id}/fetch_liquidation/${agro_exporter_process_id}/${provider_type}/${provider_id}/${liquidation_code}`
    );
  }
};
